<template>
    <img
            :src="imageSrc"
            class="file-thumbnail"
            :alt="fileName"
            :style="thumbnailStyles"
            v-if="imageSrc"
    >
</template>

<script>
    export default {
        name: 'FileThumbnail',
        props: {
            file: {
                type: [File, Object],
                required: true
            },
            thumbHeight: {
                type: String,
                required: false,
                default: '1.5rem'
            },
            thumbWidth: {
                type: String,
                required: false,
                default: '1.5rem'
            }
        },
        data: () => ({
            fileIcons: {
                pdf: 'pdf.svg',
                ppt: 'powerpoint.svg',
                pptx: 'powerpoint.svg',
                doc: 'word.svg',
                docx: 'word.svg',
                xls: 'excel.svg',
                xlsx: 'excel.svg',
                zip: 'zipped.svg',
                zipx: 'zipped.svg',
                rar: 'zipped.svg',
                '7z': 'zipped.svg'
            },
            imageExtensions: [
                'png',
                'jpg',
                'jpeg',
                'gif',
                'webp',
            ],
            imageSrc: null
        }),
        computed: {
            thumbnailStyles() {
                return {
                    height: this.thumbHeight,
                    width: this.thumbWidth
                };
            },
            fileName() {
                return this.file.name || this.file.fileTitle;
            }
        },
        methods: {
            thumbnail(file) {
                let fileIcon;
                let fileExtension = (file.name || file.fileTitle).split('.').pop().trim();
                let iconExtension = this.fileIcons[fileExtension];
                if (this.imageExtensions.includes(fileExtension)) {
                    let reader = (file) => {
                        return new Promise((resolve, reject) => {
                            let fileReader = new FileReader();
                            fileReader.onload = () => resolve(fileReader.result);
                            fileReader.readAsDataURL(file);
                        });
                    };
                    reader(file).then(result => (this.imageSrc = result));
                } else {
                    if (iconExtension) {
                        fileIcon = `${require('./../../static/file-icons/' + iconExtension)}`;
                        if (fileIcon) {
                            this.imageSrc = fileIcon;
                        }
                    }
                }
            }
        },
        watch: {
            file: {
                immediate: true,
                handler() {
                    this.thumbnail(this.file);
                }
            }
        }
    };
</script>

<style
        lang="scss"
        scoped
>
    .file-thumbnail {
        border-radius: 4px;
        object-fit:    cover;
    }
</style>
